// extracted by mini-css-extract-plugin
export var formInfo = "fB_MS";
export var formInfo__image = "fB_MM";
export var formInfo__link = "fB_MR";
export var formInfo__list = "fB_MP";
export var formInfo__sectionHr = "fB_MQ";
export var formInfo__services = "fB_ML";
export var formInfo__title = "fB_MN";